<template>
  <div class="animated fadeIn">
    <component v-if="info" ref="iface" :is="iface" :sample_id="info.sample_id" :key="info.sample_id"
      :label_set_id="info.label_set_id" :info="info" :img_type="(info.sample.files.length > 0 ? 'sample' : 'detection')" :disabled="isDisabled" :label_objects="label_objects"
      @sample-labels-updated="setLabelObjects" @save-requested="save">
      <template v-slot:form>
        <b-card class="m-0" header-class="p-2" body-class="p-2">
          <div slot="header">
            <div class="d-flex justify-content-between">
              <slot name="nav-buttons"></slot>
              <div>
                <b-button type="submit" class="ml-1" variant="success" @click="$refs.iface.save()"
                  :disabled="isDisabled" v-if="!debugHistoricActivity">
                  <!-- <b-spinner v-if="spinners.isSaving" type="grow" small/> -->
                  {{ $t('global.save') }}
                </b-button>
                <b-dropdown id="dropdown-1" class="ml-1" toggle-class="text-decoration-none" no-caret right>
                  <template #button-content>
                    <i class="fa fa-lg fa-bars fa-solid" />
                  </template>
                  <b-dropdown-item @click="showJsonDebug = !showJsonDebug, scrollMeTo('polygons_json')">
                    <i class="fa fa-lg fa-code" />{{ $dt('label_object_set.view_json_btn', 'View JSON') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showingHistoricActivities = !showingHistoricActivities">
                    <i class="fa fa-lg fa-history" />{{ $dt('label_object_set.view_historic_activities', 'View History')
                    }}
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="!file" @click="downloadFile()">
                    <i class="fa fa-lg fa-download" />
                    {{ $dt('label_object_set.download_file_btn', 'Download first File') }}
                  </b-dropdown-item>
                  <b-dropdown-item @click="showSettings()">
                    <i class="fa fa-lg fa-cog" />
                    {{ $dt('label_object_set.dropdown.settings', 'Settings') }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <div>
            <b-form-group :invalid-feedback="fErr('is_verified')" class="mb-0">
              <b-form-checkbox type="text" :class="['mb-1', { 'is-invalid': fErr('is_verified') }]"
                v-model="entity.is_verified">{{ $dt('label_object_set.is_verified', 'Verified') }}</b-form-checkbox>
              <!-- <treeselect
                  :placeholder="$t('label__set_samples_list.placeholders.tags')"
                  :multiple="true" :load-options="autocompleteTag" :async="true" :defaultOptions="true" v-model="entity.tags"/> -->
              <TagSelect :placeholder="$t('label__set_samples_list.placeholders.tags')" config="async" :delayed="false"
                :custom="{ multiple: true }" v-model="entity.tags" :showColorTag="true" />
            </b-form-group>
          </div>
        </b-card>
        <LabelSetActivities :sampleId="sample_id" v-if="showingHistoricActivities" :labelSetId="label_set_id"
          @activityClick="activityClick" @close="closeActivities" :selectedActivityId="selectedActivityId">
          <template slot="list-buttons">
            <b-button size="sm" variant="outline-secondary" @click="closeActivityDebug" v-if="debugHistoricActivity">
              <i class="fa fa-lg fa-times" />
            </b-button>
            <b-button size="sm" variant="success" @click="save()" v-if="debugHistoricActivity">
              {{ $dt('label_object_set.save_historic_activity', 'Restore & Save') }}
            </b-button>
          </template>
        </LabelSetActivities>
      </template>
    </component>
    <div ref="polygons_json">
      <b-card v-show="showJsonDebug" body-class="p-2">
        <b-button size="sm" variant="danger" @click="showJsonDebug = false">
          {{ $dt('label_object_set.close_json_debug', 'Hide JSON debug') }}
        </b-button>
        <b-card v-for="(content, idx) in this.deserialized_polygons" :key="idx" body-class="p-2" class="my-1">
          <code>{{ content }}</code>
        </b-card>
      </b-card>
    </div>

    <b-modal id="settingsModal" ref="settingsModal" size="md">
      <template #modal-title>
        Editor Settings
      </template>

      <form id="editor-settings-form" @submit.prevent="onSettingsSave">
        <b-form-group
          :label="$dt('SegmentIface.settings.default_polygon_size', 'Default polygon size (px)')"
        >
          <div class="d-flex" style="gap: 1rem;">
            <b-form-group
              :label="$dt('SegmentIface.settings.width', 'Width')"
            >
              <b-input
                v-model="editorSettings.default_polygon_size[0]"
                type="number"
                min="1"
              />
            </b-form-group>
            <b-form-group
              :label="$dt('SegmentIface.settings.height', 'Height')"
            >
              <b-input
                v-model="editorSettings.default_polygon_size[1]"
                type="number"
                min="1"
              />
            </b-form-group>
          </div>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="editorSettings.disable_image_smoothing"
          >
            {{ $dt('SegmentIface.settings.default_polygon_size', 'Disable image smoothing (requires reload)') }}
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            v-model="editorSettings.polygon_copy_to_mouse_pos"
          >
            {{ $dt('SegmentIface.settings.polygon_copy_to_mouse_pos', 'Copy poligons to mouse position (requires reload)') }}
          </b-form-checkbox>
        </b-form-group>
      </form>

      <template #modal-footer>
        <div class="float-left">
          <b-button
            variant="primary"
            type="submit"
            form="editor-settings-form"
          >
            {{ $dt('global.save') }}
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="unsavedChangesModal" ref="unsavedChangesModal" size="sm" no-close-on-esc hide-header>
      <template #default>
        {{ $dt('label_object_set.unsaved_changes.title', 'You have unsaved changes.') }}
      </template>
      <template #modal-footer="{ ok, cancel, hide }">
        <div class="w-100">
          <b-button block class="d-flex justify-content-between align-items-center" variant="secondary" @click="hide">
            <span>{{ $dt('label_object_set.unsaved_changes.cancel', 'Cancel') }}</span>
            <b-badge variant="light">esc</b-badge>
          </b-button>
          <b-button block class="d-flex justify-content-between align-items-center" variant="danger" @click="cancel">
            <span class="float-left">
              {{ $dt('label_object_set.unsaved_changes.discard_and_continue', 'Discard and continue') }}
            </span>
            <b-badge variant="light">ctrl + esc</b-badge>
          </b-button>
          <b-button block class="d-flex justify-content-between align-items-center" variant="primary" @click="ok">
            <span class="float-left">{{ $dt('label_object_set.unsaved_changes.save_and_continue', 'Save and continue')
              }}</span>
            <b-badge variant="light">enter</b-badge>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import merge from 'lodash.merge';
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import isEqual from 'lodash.isequal';
import Services from '@/services/index';
import SegmentIfaceService from '@/services/segmentationInterface';
import ClassifyIface from '@/views/LabelObjectSets/ClassifyIface.vue';
import SegmentIface from '@/views/LabelObjectSets/SegmentIface.vue';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import TagSelect from '@/views/Shared/TagSelect.vue';
import LabelSetActivities from '@/views/LabelSets/LabelSetActivities.vue';
import { downloadImage } from '@/shared/utils';
import { extFromMime } from '@/shared/classes';

export default {
  created() {
    this.editorSettings = SegmentIfaceService.getInterfaceSettings();
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      info: null,
      entity: this.value,
      label_objects: [],
      // Hash is used to check if label_objects have changed when navigating between samples
      loadedLabelObjectHash: null,
      showJsonDebug: false,
      showingHistoricActivities: false,
      debugHistoricActivity: false,
      selectedActivityId: null,
      loadedLabelObjects: [],
      editorSettings: SegmentIfaceService.getDefaultInterfaceSettings(),
    };
  },
  props: {
    sample_id: { type: Number, default: null },
    label_set_id: { type: Number, default: null },
    disabled: { type: Boolean, default: false },

    value: {
      type: Object,
      default() {
        return {
          is_verified: false,
          tags: [],
        };
      },
    },
  },
  components: {
    ClassifyIface, SegmentIface, TagSelect, LabelSetActivities
  },
  computed: {
    // embedded form will have value passed using v-model, we could also make a custom prop for checking this
    isEmbedded() { return this.$options.propsData.value !== undefined; },
    isDisabled() { return this.disabled || this.debugHistoricActivity; },
    ...mapState('Auth', ['activeProjectId']),
    ...mapGetters('Auth', ['fileUrl']),
    projectId() { return this.project_id || this.activeProjectId; },
    file() { return this.info && this.info.sample && Array.isArray(this.info.sample.files) && this.info.sample.files.length ? this.info.sample.files[0] : null; },
    sampleSetId() { return this.info && this.info.sample ? this.info.sample.sample_set_id : null; },
    iface() {
      const mapping = {
        CLASSIFY: 'ClassifyIface',
        SEGMENT: 'SegmentIface',
      };
      const dataType = this.info && this.info.label_set && this.info.label_set.data_type ? this.info.label_set.data_type : 'CLASSIFY';
      return mapping[dataType] || mapping['CLASSIFY'];
      // return mapping['CLASSIFY'];
    },
    deserialized_polygons() {
      return this.label_objects.map((e) => {
        let polyogns = '';
        if (e.config) {
          polyogns = JSON.parse(e.config)['polygons'];
        }
        return {
          polygons: polyogns,
          tag_ids: e.tags,
        };
      });
    },
  },
  watch: {
    sample_id() { this.load(); },
    label_set_id() { this.load(); }
  },
  methods: {
    showSettings() {
      this.$refs.settingsModal.show();
    },
    onSettingsSave() {
      try {
        SegmentIfaceService.setInterfaceSettings(this.editorSettings);
        this.$refs.settingsModal.hide();
      } catch (error) {
        console.error(error);
        this.alertError();
      }
    },
    downloadFile() {
      downloadImage(
        this.fileUrl(this.file.id, this.sampleSetId),
        `ss${this.sampleSetId}_s${this.file.sample_id}_f${this.file.id}${extFromMime(this.file.mime, true)}`
      );
    },
    setLabelObjects(value) {
      this.label_objects = value;
    },
    load() {
      this.selectedActivityId = null;
      this.debugHistoricActivity = false;

      Services.sampleLabelSets.info(this.projectId, this.label_set_id, this.sample_id).then(({ data }) => {
        this.info = data.info;
        this.label_objects = data.label_objects;
        this.loadedLabelObjects = this.label_objects;
        this.entity = { ...this.$options.props.value.default(), ...(data.label_object_set || {}) };

        this.$root.$emit('current-title', { title: this.$dt('label_object_set.sample_title', 'Sample {name}', { name: `${this.info.sample.name}` }) });
      }).catch((err) => {
        console.error(err);
      });
    },
    save() {
      if (this.isEmbedded) return;
      this.selectedActivityId = null;
      this.debugHistoricActivity = false;

      // eslint-disable-next-line camelcase
      const { label_set_id, sample_id } = this;
      Services.sampleLabelSets.store(this.projectId, label_set_id, sample_id, {
        label_object_set: this.entity,
        label_objects: this.label_objects,
      }).then(({ data }) => {
        // this.spinners.isSaving = false;
        this.alertSuccess();

        // Check if sample and labelset is still the same, if not return
        // otherwise there is bug when new sample data is overwritten with previously saved sample data
        // eslint-disable-next-line camelcase
        if (label_set_id !== this.label_set_id || sample_id !== this.sample_id) {
          return;
        }

        merge(this.entity, data.label_object_set); // This will not delete keys but will preserve original object
        this.label_objects = data.label_objects;
        this.loadedLabelObjects = this.label_objects;
        this.errorMsg = {};
      }).catch(({ errors, message }) => {
        this.errorMsg = errors;
        this.alertError({ text: message });
      });
    },
    scrollMeTo(refName) {
      Vue.nextTick(() => {
        if (this.showJsonDebug) {
          const element = this.$refs[refName];
          const top = element.offsetTop + element.clientHeight;

          window.scrollTo(0, top);
        }
      });
    },
    closeActivities() {
      if (this.selectedActivityId) this.load();
      this.showingHistoricActivities = false;
    },
    closeActivityDebug() {
      if (this.selectedActivityId) this.load();
    },
    activityClick(item) {
      if (!item.properties || !item.properties.attributes) return;
      this.selectedActivityId = item.id;
      this.debugHistoricActivity = true;
      this.$emit('input', item.properties.attributes);
      this.label_objects = item.properties.attributes.label_objects.map((e) => ({
        ...e,
        tags_data: e.tags,
        tags: e.tags.map((t) => t.id),
        id: null,
      }));
    },
    onModalKeyDown(e) {
      switch (e.key) {
        case 'Escape':
          this.$refs.unsavedChangesModal.hide(e.ctrlKey ? 'cancel' : undefined);
          break;
        case 'Enter':
          this.$refs.unsavedChangesModal.hide('ok');
          break;
        default:
          break;
      }
    },
    async checkForUnsavedChanges() {
      const mappedLabelObjects = this.label_objects.map((object) => {
        return {
          ...object,
          uuid: null
        };
      });

      const loadedLabelObjects = this.loadedLabelObjects.map((object) => {
        return {
          ...object,
          uuid: null
        };
      });

      if (isEqual(loadedLabelObjects, mappedLabelObjects)) {
        return Promise.resolve();
      }

      this.$refs.unsavedChangesModal.show();
      window.addEventListener('keydown', this.onModalKeyDown);
      // return promise so that router knows to wait for it
      return new Promise((resolve, reject) => {
        this.$refs.unsavedChangesModal.$on('hide', (event) => {
          window.removeEventListener('keydown', this.onModalKeyDown);
          if (event.trigger === 'ok') {
            this.save();
            resolve();
          } else if (event.trigger === 'cancel') { // cancel === discard changes.
            resolve();
          } else {
            reject();
          }

          this.$refs.unsavedChangesModal.$off('hide');
        });
      });
    },
  }
};
</script>
